'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Navigation;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Links = require('shared/components/Links');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "navigation",
    "links": [
      {
        "label": "A page",
        "href": "/a-page-url",
				"linkIcon": "shared/images/icon/icon.png"
      },
      {
        "label": "A Second Page",
        "href": "/a-second-page-url",
				"linkIcon": "shared/images/icon/icon.png"
      }
    ]
  }

  For displaying a sidebar navigational element. Accepts a links attribute,
  which is an array of link objects, each containing a label and a href.

  A link object can in turn have its own nested links:

  {
    "type": "navigation",
    "links": [
      {
        "label": "Careers in Financial Services",
        "href": "/careers",
        "links": [
          {
            "label": "Banking",
            "href": "/banking",
						"linkIcon": "shared/images/icon/icon.png"
          },
          {
            "label": "Insurance",
            "href": "/insurance",
						"linkIcon": "shared/images/icon/icon.png"
          }
        ]
      }
    ]
  }

  An example of nested links can be seen on the Sub-Sector template.
*/

function Navigation(_ref) {
  var moduleClass = _ref.moduleClass,
      addClass = _ref.addClass,
      links = _ref.links;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-navigation ' + moduleClass + ' ' + addClass
    },
    _react2.default.createElement(_Links.Links, { links: links })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Navigation/Navigation.jsx
// module id = 1249
// module chunks = 0